import { getPrimaryTopics } from "@/services/events/topics.service";

let eventCategories = {
  pulse_country: "pulse_country",
  pulse_region: "pulse_region",
  pulse_city: "pulse_city",
  pulse_county: "pulse_county",
  pulse_details_summary: "pulse_details_summary",
  pulse_details_content: "pulse_details_content",
  pulse_details_analytics: "pulse_details_analytics",
  pulse_changes: "pulse_changes",
  pulse_changes_num_days: "pulse_changes_num_days",
  pulse_changes_sort: "pulse_changes_sort",
  pulse_changes_filter: "pulse_changes_filter",
  pulse_changes_item: "pulse_changes_item_country_link",
  control_risk_risk_ratings: "risk_ratings",
  control_risk_risk_rating_changes: "risk_rating_changes",
  control_risk_risk_ratings_overview: "risk_ratings_overview",
  control_risk_events_verified: "events_verified",
  control_risk_events_maritime: "verified_maritime",
  control_risk_events_political: "verified_political",
  evacuation: "evacuation",
  hotspots: "hotspots",
  hotspotsCovid: "hotspots_covid",
  hotspots_details_summary: "hotspots_details_summary",
  hotspots_details_content: "hotspots_details_content",
  hotspots_details_analytics: "hotspots_details_analytics",
  find_location: "find_location",
  travel: "travel",
  news: "news",
  time_slider: "time_slider",
  goto_v1: "goto_v1",
  alerted_content: "alerted_content",
  social: "social",
  places: "places",
  monitor: "watch",
  alert_world_wide: "alert_world_wide",
  alert_aoi_custom_drawn: "alert_aoi_custom_drawn",
  alert_aoi_select_city: "alert_aoi_select_city",
  alert_aoi_select_country: "alert_aoi_select_country",
  alerts: "alerts",
  alert_wizard: "alert_wizard",
  dashboards: "dashboards",
  menu: "menu",
  event_details_source: "event_details_source",
  map: "map",
  events: "events",
  events_sub_events: "sub events",
  selector_source: "selector_source",
  esri_dashboard: "esri",
  pulse_opacity: "pulse_opacity",
  pulse_level: "pulse_level",
  pulse: "pulse",
  system: "system",
  collaboration: "collaboration",
  scribe: "scribe",
  mass_communication: "mass_communication",
  isos: "isos",
  reportWidget: "reportWidget",
  settings: "settings",
  powerOutage: "powerOutage",
  analysis: "analysis",
  cyber: "cyber",
  personalTargets: "personalTargets",
  headlines: "headlines",
  firi: "firi",
  country_link: "country_link",
  future_events: "future_events",
};

let latestCategories = {
  latest: "latest",
  latest_filters: "latest_filters",
  headlines: "latest_headlines",
  headlines_item: "latest_headlines_item_country_link",
  pulse_changes: "latest_pulse_changes",
  pulse_changes_num_days: "latest_pulse_changes_num_days",
  pulse_changes_sort: "latest_pulse_changes_sort",
  pulse_changes_filter: "latest_pulse_changes_filter",
  pulse_changes_item: "latest_pulse_changes_item_country_link",
  subscribe_digests: "latest_subscribe_digests",
  risk_rating_changes: "latest_risk_ratings",
  elections: "latest_elections",
  hotspots: "latest_hotspots",
};

let searchCategories = {
  live_search: "live_search",
  live_search_keyword: "live_search_keyword",
  live_search_start_date: "live_search_start_date",
  live_search_end_date: "live_search_end_date",
  live_search_bounds: "live_search_bounds",
  live_search_bounds_type: "live_search_bounds_type",
  live_search_places: "live_search_places",
  live_search_events: "live_search_events",
  live_search_sources: "live_search_sources",
  global_search_location: "global_search_location",
  global_search_keyword: "global_search_keyword",
  live_search_saved_queries: "live_search_saved_queries",
  live_search_risk_categories: "live_search_risk_categories",
  live_search_risk_category_tags: "live_search_risk_category_tags",
  live_search_notification: "live_search_notification",
};

const alertsv2Categories = {
  alertsv2: "alertsv2",
  alertsv2_saved_search: "alertsv2_saved_search",
  alertsv2_risk_rating: "alertsv2_risk_rating",
  alertsv2_evacuation: "alertsv2_evacuation",
  alertsv2_hotspot: "alertsv2_hotspot",
  alertsv2_pulse: "alertsv2_pulse",
  alertsv2_frequency: "alertsv2_frequency",
  alertsv2_expiration: "alertsv2_expiration",
  alertsv2_delivery: "alertsv2_delivery",
  alertsv2_sharing: "alertsv2_sharing",
};

let eventActions = {
  selected: "selected",
  clicked: "clicked",
  changed: "changed",
  opened: "opened",
  closed: "closed",
  addDataToMap: "addDataToMap",
  useMapType: "useMapType",
  clear: "clear",
  entered: "entered",
  loggedIn: "loggedIn",
  loggedOut: "loggedOut",
  enabled: "enabled",
  expanded: "expanded",
  scrolled: "scrolled",
};

let eventTypes = {
  button: "button",
  tab: "tab",
  slider: "slider",
  pulse: "pulse",
};

let contentTypes = {
  events: "events",
  analysis: "analysis",
};

export function setTopicEventCategories() {
  const PRIMARY_TOPICS = getPrimaryTopics();
  PRIMARY_TOPICS.forEach((topic) => {
    eventCategories[topic.type] = topic.type;
  });
}

export function convertContentTypeToEventCategory(type) {
  if (type === "analysis") {
    return eventCategories.analysis;
  } else if (type === "news") {
    return eventCategories.news;
  } else if (type === "twitter") {
    return eventCategories.social;
  } else if (type === "maritime") {
    return eventCategories.control_risk_events_maritime;
  } else if (type === "political") {
    return eventCategories.control_risk_events_political;
  } else if (type === "risk-rating-change") {
    return eventCategories.control_risk_risk_rating_changes;
  } else if (type === "evacuation") {
    return eventCategories.evacuation;
  } else {
    return null;
  }
}

export const EVENT_CATEGORIES = eventCategories;

export const EVENT_ACTIONS = eventActions;

export const EVENT_TYPE = eventTypes;

export const SEARCH_CATEGORIES = searchCategories;

export const CONTENT_TYPES = contentTypes;

export const LATEST_CATEGORIES = latestCategories;

export const ALERTSV2_CATEGORIES = alertsv2Categories;
